<template>
  <div>
    <el-dialog
      title="加入黑名单"
      :visible.sync="dialogFormVisibleHMD"
      @close="dialogFormVisibleBlack"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="50%"
    >
      <div class="el-dialog__body displayflex">
            <div style="color: red;padding: 0 5px;width: 70px;">*备注:</div>
        <el-input
          type="textarea"
          autosize
          placeholder="请输入内容"
          v-model="textarea1"
        >
        </el-input>
      </div>

      <div class="el-dialog__body displayflex">
        <div style="color: red;padding: 0 5px;width: 70px;">*操作员:</div>
        <el-input
          type="textarea"
          autosize
          placeholder="请输入内容"
          v-model="operator"
        >
        </el-input>
      </div>
      <div class="el-dialog__body">
        <el-button type="primary" @click="HmdExport()">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import OrderApi from "@/api/order.js";
export default {
  props: ["order_id"],
  data() {
    return {
      dialogFormVisibleHMD: true,
      textarea1: "",
      operator:""
    };
  },
  methods: {
    // 确定
    HmdExport() {
      console.log(this.textarea1);
      if (!this.textarea1) {
        this.$message({
          showClose: true,
          message: "请填写备注",
          type: "error",
        });
        return;
      } else if (!this.operator) {
        this.$message({
          showClose: true,
          message: "请填写操作员",
          type: "error",
        });
        return;
      }
      this.$emit("close", { openDialog: false });
      this.$message({
        showClose: true,
        message: "操作成功",
        type: "success",
      });
    },
    /*关闭弹窗*/
    dialogFormVisibleBlack() {
      this.$emit("close", { openDialog: false });
    },
  },
  mounted() {
    console.log(this.order_id);
  },
  created() {},
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/views/order/order/dialog/blacklist.vue